import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DataModel {
  messages: string[],
  title: string,
  isError?: boolean
}

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {
  reference: DataModel = {} as DataModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DataModel
  ) { }

  ngOnInit(): void {
    Object.assign(this.reference, this.data);
  }

}
